import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, references } from '@apexdesigner/schema-tools';

export const tokenLink = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    downstreamTokenId: z.uuid().hidden().describe('Foreign key to Token'),

    upstreamTokenId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Token'),

    tenantId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Tenant'),

    downstreamToken: belongsTo('Token'),

    upstreamToken: references('Token'),

    tenant: references('Tenant'),
  })
  .describe('Connects two tokens to show the flow of execution')
  .as('TokenLink');

export { tokenLink as tokenLinkSchema };
